export default __webpack_public_path__ + "static/media/basic-push-pin-4.626c530e.png";